<template>
  <div class="d-flex justify-center flex-column align-center">
    <v-icon color="blue-grey lighten-2" large>
      mdi-beehive-outline
    </v-icon>

    <span class="subtitle-2 d-flex blue-grey--text text--darken-1 mt-3">
      {{ $t('common.nothing_to_see_here') }}
    </span>
    <span class="body-2 blue-grey--text"> {{ message }}</span>
    <Button :text="$t('common.button.create')" plain @click="$emit('create')" />
  </div>
</template>
<script>
import Button from '@/components/UI/Button.vue'

export default {
  name: 'TeamsEmptyState',

  components: {
    Button,
  },

  props: {
    message: {
      required: true,
      type: String,
    },
  },
}
</script>
